"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandGuidelines = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const configeek_main_png_1 = __importDefault(require("../common/assets/configeek_main.png"));
const configeek_white_png_1 = __importDefault(require("../common/assets/configeek_white.png"));
const configeek_black_png_1 = __importDefault(require("../common/assets/configeek_black.png"));
const ToolbarRow_1 = require("src/configeek_assets/src/components/anonymous/landing/ToolbarRow");
const BrandGuidelines = () => {
    (0, react_1.useEffect)(() => {
        setTimeout(() => window.scrollTo({ top: 0 }), 0);
    }, []);
    return React.createElement("div", { className: "anonymousLanding" },
        React.createElement("div", { className: "brandGuidelines" },
            React.createElement(ToolbarRow_1.ToolbarRow, { logoAsLinkToHome: true }),
            React.createElement("div", null,
                React.createElement("section", { className: "ug_anonym_section" },
                    React.createElement("div", { className: "ug_anonym_sectionContent pt-5 pb-5" },
                        React.createElement(antd_1.Row, { justify: "center", className: "pb-5" },
                            React.createElement(antd_1.Col, { span: 20 },
                                React.createElement("div", { className: "header2" }, "Brand guidelines"),
                                React.createElement("p", { className: "mt-5 text-center" },
                                    "Please find below 3 different color options of confiGeek logo",
                                    React.createElement("br", null),
                                    "on a transparent background."))),
                        React.createElement(antd_1.Row, { justify: "center", className: "pt-5 pb-5" },
                            React.createElement(antd_1.Col, { span: 16, className: "taCenter" },
                                React.createElement("a", { href: configeek_main_png_1.default, target: "_blank", rel: "noreferrer" },
                                    React.createElement("img", { src: configeek_main_png_1.default, alt: "confiGeek", className: "brandImage" })))),
                        React.createElement(antd_1.Row, { justify: "center", className: "pt-5 pb-5" },
                            React.createElement(antd_1.Col, { span: 16, className: "taCenter" },
                                React.createElement("a", { href: configeek_white_png_1.default, target: "_blank", rel: "noreferrer" },
                                    React.createElement("img", { src: configeek_white_png_1.default, alt: "confiGeek", className: "brandImage" })))),
                        React.createElement(antd_1.Row, { justify: "center", className: "pt-5 pb-5" },
                            React.createElement(antd_1.Col, { span: 16, className: "taCenter" },
                                React.createElement("a", { href: configeek_black_png_1.default, target: "_blank", rel: "noreferrer" },
                                    React.createElement("img", { src: configeek_black_png_1.default, alt: "confiGeek", className: "brandImage" })))))))));
};
exports.BrandGuidelines = BrandGuidelines;
